import { createRoutine } from "redux-saga-routines";
import { handleActions } from "redux-actions";

export const fetchFaqQuestionsRoutine = createRoutine(
  "app/faq/FETCH_FAQ_QUESTIONS"
);

const initialState = {
  loading: true,
  error: null,
  data: []
};

export default handleActions(
  {
    [fetchFaqQuestionsRoutine.TRIGGER]: state => ({
      ...state,
      loading: true
    }),
    [fetchFaqQuestionsRoutine.FAILURE]: (state, { payload }) => ({
      ...state,
      error: payload,
      loading: false
    }),
    [fetchFaqQuestionsRoutine.SUCCESS]: (state, { payload }) => ({
      ...state,
      error: null,
      data: payload,
      loading: false
    })
  },
  initialState
);
